export const USER_API_URL = {
  // ADDRESS
  GET_USER_BUSINESS_ADDRESS_BY_USER: 'user-business-address/user-business-address-by-user',
  UPDATE_USER_BUSINESS_ADDRESS_BULK: 'user-business-address/bulk',

  // CONTACT
  UPDATE_USER_CONTACT_BULK: 'user-contact/bulk',
  GET_USER_CONTACT_BY_USER: 'user-contact/user-contact-by-user',
};
